import React, { createContext, useContext } from "react";

const TableComparisonContext = createContext(null);

export const TableComparisonProvider = ({ value, children }) => (
  <TableComparisonContext.Provider value={value}>
    {children}
  </TableComparisonContext.Provider>
);

export const useTableComparison = () => useContext(TableComparisonContext);

export default TableComparisonContext;
